import React from 'react';
export function Footer() {
  return <footer className="bg-carbon text-gray-400 py-10 px-4" data-id="element-74">
      <div className="max-w-3xl mx-auto text-center" data-id="element-75">
        <div className="text-white font-bold text-xl tracking-widest mb-3" data-id="element-76">
          CIENCIAS 360
        </div>

        <p className="text-sm leading-relaxed mb-6" data-id="element-77">
          El sistema de planificación definitivo para
          <br data-id="element-78" />
          docentes de Física y Química de secundaria
          <br data-id="element-79" />
          en Argentina.
          <br data-id="element-80" />
          <br data-id="element-81" />
          Porque enseñar Ciencias no debería costarte
          <br data-id="element-82" />
          todos los domingos del año.
        </p>

        <div className="text-xs" data-id="element-83">
          © CIENCIAS 360 — Todos los derechos reservados
        </div>
      </div>
    </footer>;
}